@for (payment of paymentOptions$ | async; track payment.name) {
    <app-image [image]="payment" [crop]="'max'" [width]="70" [height]="25" [quality]="100"></app-image>
}
